import { createAsyncThunk } from "@reduxjs/toolkit";
import { deleteAdminPage } from "@/lib/api-server/admin/page/deleteAdminPage";
import { IAdminSlice } from "@/redux/slices/admin/types";

export const deletePage = createAsyncThunk(
  "admin/deletePage",
  async (uuid: string, { rejectWithValue }) =>
    await deleteAdminPage(uuid).then((r) => {
      if (!r.success) return rejectWithValue(r.error);
      return r.data;
    })
);

const pending = (state: IAdminSlice, { meta }: { meta: { arg: string } }) => {
  state.pages = state.pages.map((page: any) => {
    if (page.uuid === meta.arg) {
      return {
        ...page,
        loading: true,
      };
    }
    return page;
  });
};

const rejected = (state: IAdminSlice, { meta }: { meta: { arg: string } }) => {
  state.pages = state.pages.map((page: any) => {
    if (page.uuid === meta.arg) {
      return {
        ...page,
        loading: false,
      };
    }
    return page;
  });
};

const fulfilled = (
  state: IAdminSlice,
  { payload, meta }: { payload: any; meta: { arg: string } }
) => {
  state.pages = state.pages.filter((page: any) => page.uuid !== payload.uuid);
  state.current_page = state.pages?.[0]?.uuid || "";

  state.pages = state.pages.map((page: any) => {
    if (page.uuid === meta.arg) {
      return {
        ...page,
        loading: true,
      };
    }
    return page;
  });
};

export default {
  action: deletePage,
  pending,
  rejected,
  fulfilled,
};
